import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.main');
import { OnInit, ChangeDetectorRef } from "@angular/core";

@Component({
    selector: 'wiz-page-main',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.main/view.scss */
@charset "UTF-8";
/* 캘린더 전체 컨테이너 */
.calendar-container {
  width: 800px;
  margin: 0 auto;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  font-family: Arial, sans-serif;
  box-sizing: border-box;
}

/* 버튼 */
.calendar-container .btn {
  padding: 6px 12px;
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  margin: 0 4px 12px 4px;
}

.calendar-container .btn:hover {
  background-color: #e0e0e0;
}

/* 년/월 제목 */
.calendar-container h2 {
  text-align: center;
  margin: 16px 0;
  font-size: 24px;
}

/* 요일 + 날짜 전체 그리드 */
.calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 4px;
}

/* 요일 셀 */
.weekday {
  text-align: center;
  font-weight: bold;
  padding: 8px 0;
  background-color: #f0f0f0;
  border-radius: 4px;
}

.weekday.sun {
  color: #ff4d4f;
}

.weekday.sat {
  color: #1890ff;
}

/* 날짜 셀 */
.day {
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 80px; /* 높이 고정 */
  box-sizing: border-box;
}

/* 빈 날짜 셀 */
.day.empty {
  border: none;
  background-color: transparent;
}

/* 날짜 숫자 */
.day-number {
  font-size: 16px;
  font-weight: bold;
}

/* 이벤트 표시 */
.event {
  font-size: 12px;
  color: #d00;
  margin-top: 4px;
}`],
})
export class PageMainComponent implements OnInit {
  public year: number = 2025;
  public month: number = 10;
  public days: { date: number | null; event?: string }[] = [];

  constructor(@Inject( ChangeDetectorRef) private cdr: ChangeDetectorRef) {}

  public async ngOnInit() {
    await this.loadMonth();
  }

  private async loadMonth() {
    this.days = [];

    const firstDay = new Date(this.year, this.month - 1, 1).getDay();
    const daysInMonth = new Date(this.year, this.month, 0).getDate();

    const res = await wiz.call("get_calendar", { year: this.year, month: this.month });
    const events: Record<number, string> = res.data || {};

    console.log("📅 days 계산 전 events:", events);
    console.log("📦 API 전체 응답 구조:", res);
    console.log("📅 events 타입 확인:", events);
    console.log("📅 events 키:", Object.keys(events));

    // 날짜 + 이벤트 생성
    for (let i = 0; i < firstDay; i++) this.days.push({ date: null });
    for (let i = 1; i <= daysInMonth; i++) {
      const event = events[i] || undefined;
      this.days.push({ date: i, event });
    }
    while (this.days.length % 7 !== 0) this.days.push({ date: null });

    // 🧩 Angular에게 변경 사항 감지 요청
    this.cdr.detectChanges();

    console.log("📅 최종 days:", this.days);
  }

  public prevMonth() {
    this.month = this.month === 1 ? 12 : this.month - 1;
    this.loadMonth();
  }

  public nextMonth() {
    this.month = this.month === 12 ? 1 : this.month + 1;
    this.loadMonth();
  }
}

export default PageMainComponent;